import React, {useEffect, useState} from 'react';
import "./selectSongBox.scss";


  
const SelectSongBox = (props) => {

    return (
      <div className="default-songs"  >
          <div className="default-song-header" onClick={props.onSelected} >
              <button onClick={() => {}}  className={`default-song-btn ${props.isSelected ? "isChecked" : ''}`}></button>
              <div className="title" >
                  <h3>{props.title}</h3>
                  <p>{props.subTitle}</p>         
              </div>
          </div>
          <div className="default-song-body">
              {props.children}
          </div> 
      </div>
    ) ;


}

export default SelectSongBox;
